import { render } from "./GeneratedTicketHeader.vue?vue&type=template&id=3a0e3d2e"
import script from "./GeneratedTicketHeader.vue?vue&type=script&lang=js"
export * from "./GeneratedTicketHeader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__